import { useEffect, useState } from 'react';

/**
 * Delays a rapidly-changing value.
 *
 * Used for search inputs so typing a name fires one request instead of one
 * per keystroke — which matters against a 1700-row table.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
